﻿import {JSX} from "react";
import TopUserInfo from "../../components/TopUserInfo";
import Registrations from "../../customers/Registrations";

export default function Home(): JSX.Element {
	const HomeComponent = Registrations.getPermitsHome();
	return (<>
		<TopUserInfo />
		<HomeComponent/>
	</>);
}
